import { Button } from '@modules/common/components/button';

export default function OutOfStockCta() {
  return (
    <div className="flex flex-col gap-y-3">
      <Button disabled variant="primary" size="lg" className="w-full">
        <span translate="no">Out of stock</span>
      </Button>
    </div>
  );
}
